import { createContext, useCallback, useContext, useState, FC } from 'react';

interface SidebarContextData {
  toggleSidebar: () => void;
  sidebarIsVisible: boolean;
}

const SidebarContext = createContext<SidebarContextData>(
  {} as SidebarContextData,
);

const AppSidebarProvider: FC = ({ children }) => {
  const [sidebarIsVisible, setSidebarIsVisible] = useState(() => {
    const sidebarStatusVisible = localStorage.getItem(
      'IB:sidebarStatusVisible',
    );

    if (sidebarStatusVisible) {
      return JSON.parse(sidebarStatusVisible);
    }

    return true;
  });

  const toggleSidebar = useCallback(() => {
    localStorage.setItem(
      'IB:sidebarStatusVisible',
      JSON.stringify(!sidebarIsVisible),
    );
    setSidebarIsVisible((prevState: boolean) => !prevState);
  }, [sidebarIsVisible]);

  return (
    <SidebarContext.Provider value={{ toggleSidebar, sidebarIsVisible }}>
      {children}
    </SidebarContext.Provider>
  );
};

function useSidebar(): SidebarContextData {
  const context = useContext(SidebarContext);

  return context;
}

export { AppSidebarProvider, useSidebar };
